<div class="cg3-multiselect">
    <div class="cg3-host-form-field">
        <div class="cg3-form-field">
            @if (label()) {
                <div class="cg3-host-form-field-header">
                    <div class="cg3-form-field-header cg3-multiselect-field-header">
                        <div class="cg3-host-form-field-label">
                            <form-field-label-pds3>
                                <span>{{ label() | wkTranslate }}</span>
                            </form-field-label-pds3>
                        </div>
                    </div>
                </div>
            }

            <div class="cg3-host-form-field-body">
                <div class="cg3-form-field-body cg3-multiselect-body-container cg3-form-field-body-{{ size() }}">
                    <div class="cg3-form-field-body-container" (mouseover)="onHover($event)" (focusin)="onHover($event)">
                        <kendo-multiselect
                            [data]="search.filteredData()"
                            [value]="value"
                            (valueChange)="handleValueChange($event)"
                            [valuePrimitive]="valuePrimitive()"
                            [textField]="textField()"
                            [valueField]="valueField()"
                            [placeholder]="placeholder() || ('General.None' | wkTranslate)"
                            [popupSettings]="{ appendTo: 'component', popupClass: 'multiselect-wrapper-popup', animate: false }"
                            fillMode="none"
                            rounded="none"
                            [size]="size()"
                            [virtual]="
                                virtual()
                                    ? {
                                          itemHeight: size() === 'large' ? 44 : 32,
                                          pageSize: 30,
                                      }
                                    : false
                            "
                            [listHeight]="size() === 'large' ? 264 : 192"
                            [adaptiveMode]="virtual() ? 'none' : 'auto'"
                            [filterable]="filterable()"
                            (filterChange)="search.onFilterChange($event)"
                            [disabled]="disabled"
                            [tabindex]="disabled ? -1 : 0"
                            kendoMultiSelectSummaryTag
                            [autoClose]="false"
                            [checkboxes]="true"
                            class="wk-multiselect"
                            [inputAttributes]="{ class: 'cg3-multiselect-body' }"
                            closeOnAncestorScroll
                            [itemDisabled]="onItemDisabled"
                        >
                            @if (clearTitleText()) {
                                <kendo-multiselect-messages [clearTitle]="clearTitleText()"> </kendo-multiselect-messages>
                            }

                            <ng-template kendoMultiSelectHeaderTemplate>
                                <div class="wk-msw-actions wk-popup-actions">
                                    <span class="wk-msw-actions-count">({{ selectedCount() }} {{ "SearchBar.SelectedCount" | wkTranslate }})</span>
                                    <button
                                        #clearAllButton
                                        type="button"
                                        tabindex="-1"
                                        class="wk-msw-action"
                                        (mousedown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation(); clearAll()"
                                    >
                                        {{ "SearchBar.ClearAll" | wkTranslate }}
                                    </button>
                                </div>

                                @if (search.isFilterable()) {
                                    <wk-dropdown-search-box
                                        [clearLabel]="clearTitleText()"
                                        (navigate)="onListNavigate($event)"
                                        (tab)="onTab($event)"
                                    />
                                }
                            </ng-template>

                            <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                <div class="multiselect-wrapper-item" [id]="optionLabelId(dataItem)">
                                    @for (
                                        part of dataItem | nestedValue: textField() | wkTranslate | highlightMatch: search.filterTerm();
                                        track $index
                                    ) {
                                        <span [class.wk-ddlw-highlight]="part.isMatch">{{ part.text }}</span>
                                    }
                                </div>
                                @if (isClipped(optionLabelId(dataItem))) {
                                    <portal-pds3 elementId="wk-app__root">
                                        <tooltip-pds3
                                            mode="description"
                                            position="top"
                                            [openDelay]="400"
                                            [closeDelay]="50"
                                            [targetSelector]="'#' + optionLabelId(dataItem)"
                                            flowClass="wk-dropdown-wrapper-tooltip"
                                        >
                                            {{ dataItem | nestedValue: textField() | wkTranslate }}
                                        </tooltip-pds3>
                                    </portal-pds3>
                                }
                            </ng-template>

                            <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
                                <span class="multiselect-wrapper-value" [id]="valueLabelId">
                                    @if (selectionDisplay() === "text") {
                                        {{ selectedText() }}
                                    } @else {
                                        {{ dataItems.length }}
                                    }
                                </span>
                                @if (isClipped(valueLabelId)) {
                                    <portal-pds3 elementId="wk-app__root">
                                        <tooltip-pds3
                                            mode="description"
                                            position="top"
                                            [openDelay]="400"
                                            [closeDelay]="50"
                                            [targetSelector]="'#' + valueLabelId"
                                            flowClass="wk-dropdown-wrapper-tooltip"
                                        >
                                            {{ selectedText() }}
                                        </tooltip-pds3>
                                    </portal-pds3>
                                }
                            </ng-template>

                            <ng-template kendoMultiSelectNoDataTemplate>
                                <span class="text-resizing">{{ "SearchBar.NoItemsFound" | wkTranslate }}</span>
                            </ng-template>

                            <ng-template kendoSuffixTemplate>
                                <button class="wk-msw-toggle" kendoButton fillMode="none" (click)="toggleDropdown()" tabindex="-1"></button>
                            </ng-template>
                        </kendo-multiselect>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
